<script setup>
import FormularioPreregistro from '@/components/formularioPreregistro.vue';
</script>
<template>
    <FormularioPreregistro urlSiguiente="/cliente/verificar-correo" />
</template>